<template>
  <!-- Your template code goes here -->
  <div>
    <vue-headful title="Maak je profiel compleet" />
    <Header page_title="Maak je profiel compleet" />
    <div class="pt-3 px-4 mx-2 pb-4 questionnaire">
      <form @submit.prevent="onSubmit">
        <div class="step-question">
          <button type="submit" ref="submit" hidden>submit</button>
          <register-steps :steps="{1:'Gegevens',2:'Ervaringen',3:'Aan de slag!'}" :totalAnswered="90" currentStep="2"></register-steps>
          <div ref="step">
            <template v-if="(step === 1)">
              <div class="sd-title medium step-container" v-if="displayQuestion == true">
                Heb je (ook) een pabo diploma?
              </div>
              <div class="form">
                <ul id="pabo" class="list-unstyled" v-if="displayQuestion == true">
                  <li>
                    <div class="custom-control custom-radio" >
                      <input
                          type="radio"
                          class="custom-control-input"
                          v-model="questions[11].answer"
                          value="YES"
                          v-bind:id="questions[11].id + `-yes`"
                      />
                      <label
                          class="custom-control-label"
                          v-bind:for="questions[11].id + `-yes`"
                      >Ja</label>
                    </div>
                  </li>

                  <li>
                    <div class="custom-control custom-radio">
                      <input
                          type="radio"
                          class="custom-control-input"
                          v-model="questions[11].answer"
                          value="NO"
                          v-bind:id="questions[11].id + `-no`"
                      />
                      <label
                          class="custom-control-label"
                          v-bind:for="questions[11].id + `-no`"
                      >Nee</label>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </div>
        </div>
      </form>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <button
          v-if="step == steps"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="triggerSubmit"
        >
          Opslaan
        </button>
      </div>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div class="icon svg mb-4 pb-1">
              <svg-icon icon="success"></svg-icon>
            </div>
            <div class="sd-title large text-uppercase bold text-white text-center mb-4">
              Dank voor het invullen!
            </div>
            <div class="">
              Nu je profiel helemaal compleet is, word je nog beter gevonden. Op naar de leukste (inval)opdrachten!
            </div>
          </div>
        </div>

        <div class="footer-btn">
          <div class="container-fluid px-4 mx-2">
            <router-link
                :to="{
                  name: 'applicant-dashboard'
                }"
                title="Naar mijn dashboard"
                class="btn btn-light btn-block"
                v-ripple="'rgba(192, 189, 187, 0.35)'"
            >
              Naar mijn dashboard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      done: false,
      message: 'Hello, Vue!',
      subBranch: 2,
      step: 1,
      steps: 1,
      form: {
        paboDiploma: null,
      },
      questions: {},
      displayQuestion: false,
    };
  },
  props: ['answers'],
  async created() {
    await this.fetchData();
    this.displayQuestion = true;
  },
  methods: {
    async fetchData() {
      await this.getPaboQuestion();
      await this.getAnswers();
    },
    async getPaboQuestion() {
      let promises = [];
      var q_url = this.$apiURI + "/question/education/1/1/1";

      promises.push(
        new Promise(resolve => {
          this.$http({
            method: "GET",
            url: q_url
          }).then(
            result => {
              this.$set(this.questions, 11, {
                id: result.data.data[0].id,
                display: result.data.data[0].display,
                answer: ""
              });
              resolve();
            },
              error => {
                console.error(error);
              }
          );
        })
      );
    return Promise.all(promises);
    },
    async getAnswers() {
      return new Promise((resolve, reject) => {
        var url = "applicant/answers/raw/1/education";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data.data) {
              this.raw = resp.data.data;
              for (var obj in this.raw) {
                this.$set(this.questions[11], 'answer', this.raw[obj].answer);
              }
            }
            return resolve();
          }).catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject(null);
        });
      });
    },

    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async save() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/user_answer/education";

        let formData = {
          user_answer: this.questions
        };
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            this.done = true;
            localStorage.removeItem("form-pending");
            resolve();
          })
          .catch(() => {
            this.done = true;
            localStorage.removeItem("form-pending");
            resolve();
          });
      });
    },
    async onSubmit() {
        await this.save();
        await this.updateLocalUser();
    },
  },
  computed: {
    // Your computed properties go here
  },
  // Other lifecycle hooks, options, etc.
};
</script>

<style scoped>
/* Your scoped styles go here */
</style>
